import { LoanApplication } from "src/types/loan-application";

export default function isFullProposal(app: LoanApplication){
    return app.customer &&
      app.customer.bankAccountNumber !== null && app.customer.bankAccountNumber !== "" &&
      app.customer.bankSortCode !== null && app.customer.bankSortCode !== "" &&
      app.customer.bankName !== null && app.customer.bankName !== "" &&
      app.customer.bankAccountName !== null && app.customer.bankAccountName !== "" &&
      app.customer.bankMonthsAt > 0 &&
      app.customer.grossAnnualIncome !== null &&
      app.customer.grossAnnualIncome > 0 &&
      app.customer.nationalityOnLicence !== null &&
      app.customer.numberOfDependants !== null
        ? true : false;
  }